export class Asset {

    _id?: string; 
    name: string; 
    profile: string; 
    category: string;
    purchaseDate: Date; 
    status: string; 
    cost: number; 
    serialNumber: string; 
    description?: string; 
    warrantyExpiry?: Date; 
    branch: string; 
    company: string; 
    maintenanceLogs: MaintenanceLog[];

}

class MaintenanceLog {
    lastMaintenanceDate:Date;
    nextMaintenanceDate:Date;
    maintenanceDate : Date;
    maintainedBy: string;
    approvedBy: string;
    notes: string;
    cost: number;
    status: string;
    maintenanceReason:string;
    maintenanceCount: number;

}